/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Draggable from "gsap/Draggable";
import Flickity from "flickity-fade";
import Isotope from "isotope-layout";

gsap.registerPlugin(ScrollTrigger, Draggable);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggleMenus = document.querySelectorAll(".toggle-menu");
    if (toggleMenus.length) {
      const mainNav = document.querySelector(".main-nav");
      gsap.set(mainNav, { height: 0, overflow: "hidden" });

      toggleMenus.forEach((toggleMenu) => {
        toggleMenu.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");

          const height = HTML.classList.contains("open-menu")
            ? mainNav.scrollHeight
            : 0;

          gsap.to(mainNav, {
            height,
            duration: 0.3,
            ease: "circ.inOut",
            onComplete: () => {
              if (HTML.classList.contains("open-menu")) {
                gsap.set(mainNav, { height: "auto" });
              }
            },
          });
        });
      });
    }

    this.sliderFade();
    this.isotopeGrid();
    this.carousel();
    this.slider();
    this.cards();
    this.coverAnimation();
    this.highlight();
    this.marquee();
    this.inViewport();
  }

  isotopeGrid() {
    const elts = document.querySelectorAll('.isotope-grid');

    if( elts ) {
      elts.forEach(el => {
        const iso = new Isotope( el, {
          // options
          itemSelector: '.item',
          layoutMode: 'masonry'
        });
      })
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts) {
      console.log(window.innerWidth);
      elts.forEach((el) => {
        const scrollbar = el.querySelector(".scrollbar");
        const bar = el.querySelectorAll(".bar");
        const cursor = el.querySelector(".cursor");
        let move = false;

        const flkty = new Flickity(el, {
          cellSelector: ".item",
          cellAlign: el.dataset.carouselAlign
            ? el.dataset.carouselAlign
            : "left",
          autoPlay: el.dataset.carouselAutoplay && window.innerWidth > 768
            ? parseInt(el.dataset.carouselAutoplay)
            : false,
          pauseAutoPlayOnHover: true,
          pageDots: false,
          prevNextButtons: false,
          contain: !el.dataset.carouselWrap || el.dataset.carouselAutoplay,
          wrapAround: !!el.dataset.carouselWrap,
          watchCSS: true,
          on: {
            scroll: (progress) => {
              progress = Math.max(0, Math.min(1, progress));
              gsap.set(bar, {
                width: `${progress * 100}%`,
              });
              const drag = Draggable.get(cursor);
              if( drag && !move ) {
                gsap.set(cursor, {
                  x: progress * scrollbar.offsetWidth,
                });
                drag.update();
              }
            },
            select : function (index) {
              const nbVisibles = Math.round(this.slidesWidth / this.slides[index].outerWidth);
              if( el.dataset.carouselAutoplay && index + nbVisibles == this.slides.length ) {
                this.pausePlayer();
                setTimeout(() => { 
                  this.playPlayer();
                  this.select(0);
                }, el.dataset.carouselAutoplay);
              }
            }
          },
        });

        if( scrollbar && cursor ) { 
          Draggable.create(cursor, {
            type: "x",
            bounds: scrollbar,
            onDragStart: function () {
              move = true;
              flkty.pausePlayer();
            },
            onDrag: function () {
              if( move ) {
                flkty.x = -(flkty.slideableWidth - flkty.size.width) * ((this.x / this.maxX));
                flkty.positionSlider();
                flkty.dispatchEvent("scroll");
              }
            },
            onDragEnd: function () {
              move = false;
              // flkty.playPlayer();
            }
          });
        }

        el.addEventListener('wheel', (e) => {
          // On ne gère que les événements qui arrivent dans le carousel
          if (Math.abs(e.deltaX) / Math.abs(e.deltaY) <= 0.25) {
            return;
          }

          flkty.pausePlayer();
          e.preventDefault();
          move = false;

          const delta = e.deltaX;
          const max = (flkty.slideableWidth - flkty.size.width);

          flkty.x += -delta
          if( flkty.x >= 0 ) flkty.x = 0;
          else if( flkty.x <= -max ) flkty.x = -max ;

          flkty.positionSlider();

          // Progress entre 0 et 1
          const progress = max > 0
            ? -flkty.x / max
            : 0;

          flkty.dispatchEvent('scroll', null, progress);
        }, {
          passive: false
        });
      });
    }
  }

  cards() {
    const elts = document.querySelectorAll(".cards");

    if (elts) {
      elts.forEach((el) => {
        const cards = el.querySelectorAll(".card");
        const imgs = el.dataset.cardsImgs
          ? document.querySelectorAll(el.dataset.cardsImgs)
          : false;

        if (cards) {
          let current = -1;
          cards.forEach((card, i) => {
            const triggers = card.querySelectorAll(".trigger");

            if (triggers) {
              triggers.forEach((trigger) => {
                trigger.addEventListener("click", (e) => {
                  e.preventDefault();

                  if ((current >= 0 && current != i) || current == i) {
                    cards[current].classList.remove("flip");

                    if (imgs && imgs[current]) {
                      gsap.to(imgs[current], {
                        autoAlpha: 0,
                      });
                    }
                  }

                  if (current != i) {
                    card.classList.add("flip");
                    if (imgs) {
                      gsap.fromTo(
                        imgs[i],
                        {
                          autoAlpha: 0,
                          scale: 1.1,
                        },
                        {
                          autoAlpha: 1,
                          scale: 1,
                          ease: "expo.out",
                        }
                      );
                    }
                    current = i;
                  } else {
                    current = -1;
                  }
                });
              });
            }
          });
        }
      });
    }
  }

  sliderFade() {
    const elts = document.querySelectorAll(".slider-fade");

    if (elts)
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          cellSelector: ".item",
          fade: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          autoPlay: 5000,
        });
      });
  }

  slider() {
    const elts = document.querySelectorAll(".slider");

    if (elts)
      elts.forEach((el) => {
        const controls = el.querySelectorAll(".control a");
        let current = -1;

        const flkty = new Flickity(el, {
          cellSelector: ".item",
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          autoPlay: 5000,
          pauseAutoPlayOnHover: true,
          on: {
            select: (index) => {
              if (controls && controls[current]) {
                controls[current].classList.remove("active");
              }
              if (controls && controls[index]) {
                controls[index].classList.add("active");
              }

              current = index;
            },
          },
        });

        if (controls) {
          controls.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              flkty.select(i);
            });
          });
        }
      });
  }

  coverAnimation() {
    const elts = document.querySelectorAll(".cover-animation");

    if (elts) {
      elts.forEach((el) => {
        const lines = el.querySelectorAll(".lines > *");
        const logo = gsap.utils.toArray(".icon--logo-baseline path").reverse(); // el.querySelectorAll(".icon--logo-baseline path");
        const items = el.querySelectorAll(".item");

        /** INIT */
        const tl = new gsap.timeline({
          delay: 0.4,
          scrollTrigger: {
            trigger: el,
            start: "top 50%",
            toggleActions: "play none none none",
          },
        });
        tl.from(
          lines,
          {
            scaleY: 0,
            duration: 0.7,
            ease: "expo.out",
          },
          "start"
        )
          .from(
            logo,
            {
              stagger: 0.02,
              y: "120%",
              duration: 0.7,
              ease: "expo.out",
            },
            "start+=0.3"
          )
          .from(
            items,
            {
              stagger: 0.05,
              y: "30%",
              autoAlpha: 0,
              duration: 1,
              ease: "expo.out",
            },
            "start+=0.6"
          );

        gsap.set(el, { autoAlpha: 1 });

        /** SCROLL */
        if (window.innerWidth > 768) {
          gsap.to(items, {
            yPercent: (i) => -160 - i * 25,
            rotation: (i) => i * 2 - 2,
            ease: "none",
            stagger: 0.04,
            scrollTrigger: {
              trigger: el,
              start: "top top",
              end: "+=90%",
              scrub: true,
            },
          });
        }
        // gsap.to(logo, {
        //   yPercent: (i) => -160 - i * 25,
        //   ease: "power1.in",
        //   stagger: 0.02,
        //   scrollTrigger: {
        //     trigger: el,
        //     start: "top top",
        //     end: "+=40%",
        //     scrub: true,
        //   },
        // });
      });
    }
  }

  highlight() {
    const elts = document.querySelectorAll(".highlight");

    if (elts) {
      elts.forEach((el) => {
        const volets = el.querySelectorAll(".volet");

        const tl = new gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            scrub: true,
            end: "+=40%",
          },
        });

        const wVolet = window.innerWidth > 768 ? 25 : 50;
        volets.forEach((item, i) => {
          tl.to(
            item,
            {
              ease: "power2.inOut",
              clipPath: `polygon(${i * wVolet}% 0%, ${(i + 1) * wVolet}% 0%, ${
                (i + 1) * wVolet
              }% 100%, ${i * wVolet}% 100%)`,
            },
            `start+=${i * 0.01}`
          );
        });

        const items = el.querySelectorAll(".item, .wysiwyg");
        const figure = el.querySelectorAll(".item, .wysiwyg");
        const intro = el.querySelector(".wysiwyg");
        const moveY = window.innerWidth > 768 ? 10 : 2;
        items.forEach((item,i) => {
          gsap.fromTo(
            item,
            {
              y: `${moveY * (i+1) }rem`,
              ease: "none",
              autoAlpha: 0,
            },
            {
              ease: "none",
              y: `-${moveY}rem`,
              autoAlpha: 1,
              scrollTrigger: {
                trigger: el,
                start: "top bottom",
                end: "+=50%",
                scrub: true
              },
            }
          );
        })
      });
    }
  }

  marquee() {
    const _ = this;
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        let direction = track.dataset.dir; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;

        function computeWrapWidth() {
          _.lazyload.update();
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
              // Scroll vers le bas → texte va vers la gauche
              direction = Number(track.dataset.dir);
            } else if (currentScrollY < lastScrollY) {
              // Scroll vers le haut → texte va vers la droite
              direction = -1 * track.dataset.dir;
            }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        gsap.ticker.add(() => {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        });
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
